import { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { appConfig } from '../config/appConfig';
import { useContent } from '../context/ContentContext';
import { LoadingState } from '../components/LoadingState';
import { ErrorState } from '../components/ErrorState';
import { searchItems, getCategoryLabel, getTopicPath } from '../lib/contentUtils';

export function SearchPage() {
  const { data, loading, error, reload } = useContent();
  const [query, setQuery] = useState('');

  const results = useMemo(() => {
    if (!data || query.trim().length < appConfig.searchMinChars) return [];
    return searchItems(data, query, appConfig.searchResultsLimit);
  }, [data, query]);

  if (loading) return <LoadingState />;
  if (error || !data) return <ErrorState message={error ?? 'No data'} onRetry={reload} />;

  return (
    <div className="page search-page">
      <header className="page-header">
        <h1>Search the archive</h1>
        <p>Find entries by title or body text. Keyword index lookups run when your query matches indexed terms.</p>
      </header>

      <div className="search-box">
        <label htmlFor="search-input" className="visually-hidden">
          Search entries
        </label>
        <input
          id="search-input"
          type="search"
          placeholder="e.g. SNAP, pardons, DOGE, Medicare…"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          autoFocus
        />
      </div>

      {query.trim().length > 0 && query.trim().length < appConfig.searchMinChars && (
        <p className="search-hint">
          Type at least {appConfig.searchMinChars} characters to search.
        </p>
      )}

      {results.length > 0 && (
        <ul className="search-results">
          {results.map((item) => (
            <li key={item.id}>
              <Link to={getTopicPath(data, item)}>
                <span className="search-result-title">{item.title}</span>
                <span className="search-result-meta">{getCategoryLabel(item.category)}</span>
              </Link>
            </li>
          ))}
        </ul>
      )}

      {query.trim().length >= appConfig.searchMinChars && results.length === 0 && (
        <p className="search-empty">No entries matched &ldquo;{query}&rdquo;.</p>
      )}
    </div>
  );
}
